import { app } from '../../../../app';
import { Controller } from './app-idp-authenticators.controller';

app.component('companyManageApplicationIdpAuthenticators', {
    bindings: {
        application: '<',
        companyId: '<',
        idpAuthenticators: '<',
    },
    controller: Controller,
    templateUrl: require('./app-idp-authenticators.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/idp-authenticators/app-idp-authenticators.component.js